import i18n from "@/i18n";
export const LOP = [
  {
    id: "contratoLop",
    name: "Contrato",
  },
  {
    id: "cotizacionLop",
    name: "Cotización",
  },
  {
    id: "boletaLop",
    name: "Factura/Boleta",
  },

];
export const RAC = [
  {
    id: "reserva",
    name: "Reserva",
  },
  {
    id: "contrato",
    name: "Contrato",
  },
  {
    id: i18n.t("lease.quotation.id"),
    name: i18n.t("lease.quotation.name"),
  },
  {
    id: "boleta",
    name: "Factura/Boleta",
  },
  {
    id: i18n.t("lease.reference.id"),
    name: i18n.t("lease.reference.name"),
  },
];
